import { IConsentDialogContent } from '../form-consent-checkbox.component';
import { BaseConsentVariant } from './base-consent-variant';

export class BusinessDevelopmentConsentVariant extends BaseConsentVariant {
    identifier = 'consent_on_processing_data';

    protected get labelHtmlKey(): string {
        return 'form.consent.businessDev.label';
    }

    protected get dialogContent(): IConsentDialogContent {
        return {
            bodyHtmlKey: 'form.consent.businessDev.dialog.body',
            buttonTextKey: 'form.consent.businessDev.dialog.button',
        };
    }
}
